import React from 'react';
import { motion } from 'framer-motion';
import { staggerContainerVariants, fadeUpVariants } from './useScrollReveal';

const team = [
  { name: 'Edwin Guevara', title: 'Founder & CEO', photo: '/edwin.png', role: 'Dev & Operations Lead' },
  { name: 'Derek Costello', title: 'Founder & COO', photo: '/derek.png', role: 'Strategist & Consultant' },
];

const Team: React.FC = () => {
  return (
    <section id="team" className="py-32 bg-[#080808] border-t border-[#0f0f0f]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="section-label mb-5"
          >
            Our Creative Minds
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.7, ease: [0.22,1,0.36,1] }}
            className="font-serif text-[clamp(2.2rem,5vw,4.5rem)] text-white leading-tight"
          >
            The People Behind{' '}
            <span className="italic text-lime">The Magic</span>
          </motion.h2>
        </div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerContainerVariants}
          className="flex flex-col sm:flex-row items-center justify-center gap-8 max-w-3xl mx-auto"
        >
          {team.map((member) => (
            <motion.div
              key={member.name}
              variants={fadeUpVariants}
              className="group flex flex-col flex-1 max-w-sm w-full"
              whileHover={{ y: -8 }}
              transition={{ duration: 0.35 }}
            >
              {/* Photo */}
              <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden border border-[#141414] group-hover:border-lime/20 transition-colors duration-500">
                <img
                  src={member.photo}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#080808]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
                  <p className="font-dm text-xs text-lime uppercase tracking-widest">{member.role}</p>
                </div>
              </div>

              {/* Info */}
              <div className="mt-5 px-1">
                <p className="font-syne font-bold text-white text-lg">{member.name}</p>
                <p className="font-dm text-[#999] text-sm mt-1">{member.title}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Bottom quote */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
          className="mt-20 text-center max-w-2xl mx-auto border border-[#141414] rounded-2xl p-10"
        >
          <p className="font-serif text-xl text-[#bbb] italic leading-relaxed">
            "We started SiteStackCo because we believe every small business deserves a presence that competes with the big guys — and we make that happen."
          </p>
          <div className="flex items-center justify-center gap-3 mt-6">
            <div className="w-px h-5 bg-lime" />
            <p className="font-syne text-xs text-[#888] uppercase tracking-widest">Edwin & Derek</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Team;
